import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const CommonApplicationSelection = ({ singpassNeeded }) => {
  const navigate = useNavigate();
  const ApplicationId = localStorage.getItem("applicationno");
  const id =
    ApplicationId !== undefined && ApplicationId !== null ? ApplicationId : "";
  return (
    <div className="child-radio-block">
      {singpassNeeded == true && (
        <div className="child-radio-group !block">
          <div className="w-3/3 text-center">
            <h2 className="!text-singpass-red-color">Singpass</h2>
            <p>Speed up your application using Myinfo</p>
            <Button
              onClick={(e) => {
                localStorage.setItem("SINGPASSAPPID", "");
                const currentUrl = window.location.href;
                window.location.href = `https://data.ohhto.com/?application_id=${id}&redirectUrl=${currentUrl}`;
              }}
              disabled={id === "" || id === undefined || id === null}
              className="p-3 px-4 !inline-flex !items-center !gap-2
                !font-bold !text-white !text-base !leading-6
                !bg-[#F4333D] hover:!bg-[#F4333D]/90
                !border-none !rounded-[6px]
                !cursor-pointer !no-underline !whitespace-nowrap"
              >
              Log in with{" "}
              <img src="/images/singpass.svg" className="h-6 w-auto" />
            </Button>

            <p className="text-[11px] font-[400] font-lato text-[#495159]">
              ~ 5 mins
            </p>
          </div>
        </div>
      )}
      <div className="child-radio-group ">
        <div className="w-3/3 text-center manual-container">
          <h2>Fill up Manually</h2>
          <p>Fill up the information by himself</p>
          <Button
            onClick={(e) => {
              e.preventDefault();
            }}
            className="border border-step-color-active text-step-color-active mb-1"
          >
            Fill up application form
          </Button>
          <p className="text-[11px] font-[400] font-lato text-[#495159]">
            30-45 mins
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommonApplicationSelection;
